"use strict";

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Noise = void 0;

var x25519 = __importStar(require("@stablelib/x25519"));

var buffer_1 = require("buffer");

var it_pb_rpc_1 = __importDefault(require("it-pb-rpc"));

var duplex_1 = __importDefault(require("it-pair/duplex"));

var it_buffer_1 = __importDefault(require("it-buffer"));

var it_pipe_1 = __importDefault(require("it-pipe"));

var it_length_prefixed_1 = require("it-length-prefixed");

var handshake_xx_1 = require("./handshake-xx");

var handshake_ik_1 = require("./handshake-ik");

var handshake_xx_fallback_1 = require("./handshake-xx-fallback");

var utils_1 = require("./utils");

var encoder_1 = require("./encoder");

var crypto_1 = require("./crypto");

var keycache_1 = require("./keycache");

var logger_1 = require("./logger");

var constants_1 = require("./constants");

var Noise = /*#__PURE__*/function () {
  /**
   *
   * @param {bytes} staticNoiseKey - x25519 private key, reuse for faster handshakes
   * @param {bytes} earlyData
   */
  function Noise(staticNoiseKey, earlyData) {
    _classCallCheck(this, Noise);

    this.protocol = '/noise';
    this.prologue = buffer_1.Buffer.alloc(0);
    this.earlyData = earlyData !== null && earlyData !== void 0 ? earlyData : buffer_1.Buffer.alloc(0); // disabled until properly specked

    this.useNoisePipes = false;

    if (staticNoiseKey) {
      // accepts x25519 private key of length 32
      var keyPair = x25519.generateKeyPairFromSeed(staticNoiseKey);
      this.staticKeys = {
        privateKey: buffer_1.Buffer.from(keyPair.secretKey.buffer, keyPair.secretKey.byteOffset, keyPair.secretKey.length),
        publicKey: buffer_1.Buffer.from(keyPair.publicKey.buffer, keyPair.publicKey.byteOffset, keyPair.publicKey.length)
      };
    } else {
      this.staticKeys = utils_1.generateKeypair();
    }
  }
  /**
   * Encrypt outgoing data to the remote party (handshake as initiator)
   *
   * @param {PeerId} localPeer - PeerId of the receiving peer
   * @param {any} connection - streaming iterable duplex that will be encrypted
   * @param {PeerId} remotePeer - PeerId of the remote peer. Used to validate the integrity of the remote peer.
   * @returns {Promise<SecureOutbound>}
   */


  _createClass(Noise, [{
    key: "secureOutbound",
    value: function () {
      var _secureOutbound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(localPeer, connection, remotePeer) {
        var wrappedConnection, handshake, conn;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                wrappedConnection = it_pb_rpc_1.default(connection, {
                  lengthEncoder: encoder_1.uint16BEEncode,
                  lengthDecoder: encoder_1.uint16BEDecode,
                  maxDataLength: constants_1.NOISE_MSG_MAX_LENGTH_BYTES
                });
                _context.next = 3;
                return this.performHandshake({
                  connection: wrappedConnection,
                  isInitiator: true,
                  localPeer: localPeer,
                  remotePeer: remotePeer
                });

              case 3:
                handshake = _context.sent;
                _context.next = 6;
                return this.createSecureConnection(wrappedConnection, handshake);

              case 6:
                conn = _context.sent;
                return _context.abrupt("return", {
                  conn: conn,
                  remoteEarlyData: handshake.remoteEarlyData,
                  remotePeer: handshake.remotePeer
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function secureOutbound(_x, _x2, _x3) {
        return _secureOutbound.apply(this, arguments);
      }

      return secureOutbound;
    }()
    /**
     * Decrypt incoming data (handshake as responder).
     *
     * @param {PeerId} localPeer - PeerId of the receiving peer.
     * @param {any} connection - streaming iterable duplex that will be encryption.
     * @param {PeerId} remotePeer - optional PeerId of the initiating peer, if known. This may only exist during transport upgrades.
     * @returns {Promise<SecureOutbound>}
     */

  }, {
    key: "secureInbound",
    value: function () {
      var _secureInbound = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(localPeer, connection, remotePeer) {
        var wrappedConnection, handshake, conn;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wrappedConnection = it_pb_rpc_1.default(connection, {
                  lengthEncoder: encoder_1.uint16BEEncode,
                  lengthDecoder: encoder_1.uint16BEDecode,
                  maxDataLength: constants_1.NOISE_MSG_MAX_LENGTH_BYTES
                });
                _context2.next = 3;
                return this.performHandshake({
                  connection: wrappedConnection,
                  isInitiator: false,
                  localPeer: localPeer,
                  remotePeer: remotePeer
                });

              case 3:
                handshake = _context2.sent;
                _context2.next = 6;
                return this.createSecureConnection(wrappedConnection, handshake);

              case 6:
                conn = _context2.sent;
                return _context2.abrupt("return", {
                  conn: conn,
                  remoteEarlyData: handshake.remoteEarlyData,
                  remotePeer: handshake.remotePeer
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function secureInbound(_x4, _x5, _x6) {
        return _secureInbound.apply(this, arguments);
      }

      return secureInbound;
    }()
    /**
     * If Noise pipes supported, tries IK handshake first with XX as fallback if it fails.
     * If noise pipes disabled or remote peer static key is unknown, use XX.
     *
     * @param {HandshakeParams} params
     */

  }, {
    key: "performHandshake",
    value: function () {
      var _performHandshake = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var _a, payload, tryIK, remotePeer, connection, isInitiator, ikHandshake, ephemeralKeys;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return utils_1.getPayload(params.localPeer, this.staticKeys.publicKey, this.earlyData);

              case 2:
                payload = _context3.sent;
                tryIK = this.useNoisePipes;

                if (params.isInitiator && keycache_1.KeyCache.load(params.remotePeer) === null) {
                  // if we are initiator and remote static key is unknown, don't try IK
                  tryIK = false;
                } // Try IK if acting as responder or initiator that has remote's static key.


                if (!tryIK) {
                  _context3.next = 22;
                  break;
                }

                // Try IK first
                remotePeer = params.remotePeer, connection = params.connection, isInitiator = params.isInitiator;
                ikHandshake = new handshake_ik_1.IKHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, // safe to cast as we did checks
                (_a = keycache_1.KeyCache.load(params.remotePeer)) !== null && _a !== void 0 ? _a : buffer_1.Buffer.alloc(32), remotePeer);
                _context3.prev = 8;
                _context3.next = 11;
                return this.performIKHandshake(ikHandshake);

              case 11:
                return _context3.abrupt("return", _context3.sent);

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](8);

                // IK failed, go to XX fallback
                if (params.isInitiator) {
                  ephemeralKeys = ikHandshake.getLocalEphemeralKeys();
                }

                _context3.next = 19;
                return this.performXXFallbackHandshake(params, payload, _context3.t0.initialMsg, ephemeralKeys);

              case 19:
                return _context3.abrupt("return", _context3.sent);

              case 20:
                _context3.next = 25;
                break;

              case 22:
                _context3.next = 24;
                return this.performXXHandshake(params, payload);

              case 24:
                return _context3.abrupt("return", _context3.sent);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 14]]);
      }));

      function performHandshake(_x7) {
        return _performHandshake.apply(this, arguments);
      }

      return performHandshake;
    }()
  }, {
    key: "performXXFallbackHandshake",
    value: function () {
      var _performXXFallbackHandshake = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, payload, initialMsg, ephemeralKeys) {
        var isInitiator, remotePeer, connection, handshake, err;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isInitiator = params.isInitiator, remotePeer = params.remotePeer, connection = params.connection;
                handshake = new handshake_xx_fallback_1.XXFallbackHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, initialMsg, remotePeer, ephemeralKeys);
                _context4.prev = 2;
                _context4.next = 5;
                return handshake.propose();

              case 5:
                _context4.next = 7;
                return handshake.exchange();

              case 7:
                _context4.next = 9;
                return handshake.finish();

              case 9:
                _context4.next = 16;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](2);
                logger_1.logger(_context4.t0);
                err = _context4.t0;
                throw new Error("Error occurred during XX Fallback handshake: ".concat(err.message));

              case 16:
                return _context4.abrupt("return", handshake);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 11]]);
      }));

      function performXXFallbackHandshake(_x8, _x9, _x10, _x11) {
        return _performXXFallbackHandshake.apply(this, arguments);
      }

      return performXXFallbackHandshake;
    }()
  }, {
    key: "performXXHandshake",
    value: function () {
      var _performXXHandshake = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params, payload) {
        var isInitiator, remotePeer, connection, handshake, err;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                isInitiator = params.isInitiator, remotePeer = params.remotePeer, connection = params.connection;
                handshake = new handshake_xx_1.XXHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, remotePeer);
                _context5.prev = 2;
                _context5.next = 5;
                return handshake.propose();

              case 5:
                _context5.next = 7;
                return handshake.exchange();

              case 7:
                _context5.next = 9;
                return handshake.finish();

              case 9:
                if (this.useNoisePipes && handshake.remotePeer) {
                  keycache_1.KeyCache.store(handshake.remotePeer, handshake.getRemoteStaticKey());
                }

                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](2);
                err = _context5.t0;
                throw new Error("Error occurred during XX handshake: ".concat(err.message));

              case 16:
                return _context5.abrupt("return", handshake);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 12]]);
      }));

      function performXXHandshake(_x12, _x13) {
        return _performXXHandshake.apply(this, arguments);
      }

      return performXXHandshake;
    }()
  }, {
    key: "performIKHandshake",
    value: function () {
      var _performIKHandshake = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(handshake) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return handshake.stage0();

              case 2:
                _context6.next = 4;
                return handshake.stage1();

              case 4:
                return _context6.abrupt("return", handshake);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function performIKHandshake(_x14) {
        return _performIKHandshake.apply(this, arguments);
      }

      return performIKHandshake;
    }()
  }, {
    key: "createSecureConnection",
    value: function () {
      var _createSecureConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(connection, handshake) {
        var _duplex_1$default, _duplex_1$default2, secure, user, network;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // Create encryption box/unbox wrapper
                _duplex_1$default = duplex_1.default(), _duplex_1$default2 = _slicedToArray(_duplex_1$default, 2), secure = _duplex_1$default2[0], user = _duplex_1$default2[1];
                network = connection.unwrap();
                _context7.next = 4;
                return it_pipe_1.default(secure, // write to wrapper
                it_buffer_1.default, // ensure any type of data is converted to buffer
                crypto_1.encryptStream(handshake), // data is encrypted
                it_length_prefixed_1.encode({
                  lengthEncoder: encoder_1.uint16BEEncode
                }), // prefix with message length
                network, // send to the remote peer
                it_length_prefixed_1.decode({
                  lengthDecoder: encoder_1.uint16BEDecode
                }), // read message length prefix
                it_buffer_1.default, // ensure any type of data is converted to buffer
                crypto_1.decryptStream(handshake), // decrypt the incoming data
                secure // pipe to the wrapper
                );

              case 4:
                return _context7.abrupt("return", user);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function createSecureConnection(_x15, _x16) {
        return _createSecureConnection.apply(this, arguments);
      }

      return createSecureConnection;
    }()
  }]);

  return Noise;
}();

exports.Noise = Noise;